import { createContext, useContext } from 'react';

interface IFeatureRolloutContextData {
    hasFeature: (name: string) => boolean;
}

const FeatureRolloutContext = createContext<IFeatureRolloutContextData>(null);

export const useFeatureRolloutContext = () => {
    const context = useContext(FeatureRolloutContext);

    if (context == null) {
        throw new Error('FeatureRolloutContext must be used within <FeatureRolloutProvider />');
    }

    return context;
};

export default FeatureRolloutContext;
